import apiClient, { storage, AUTH_KEYS } from './apiClient';

// Auth service — mirrors r2b-restaurant-mobile-new/src/services/authService.js
// but uses synchronous localStorage instead of AsyncStorage.

export const login = async (phoneNumber) => {
  try {
    const response = await apiClient.post('/login', { phoneNumber });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const verifyLogin = async (phoneNumber, otp) => {
  try {
    const response = await apiClient.post('/verify-login', { phoneNumber, otp });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const logout = async () => {
  try {
    storage.remove(AUTH_KEYS.token);
    storage.remove(AUTH_KEYS.refreshToken);
    storage.remove(AUTH_KEYS.user);
  } catch (error) {
    // eslint-disable-next-line no-console
    
  }
};

export const getStoredAuth = () => {
  try {
    const token = storage.get(AUTH_KEYS.token);
    const userJson = storage.get(AUTH_KEYS.user);
    return { token, user: userJson ? JSON.parse(userJson) : null };
  } catch (error) {
    // eslint-disable-next-line no-console
    
    return { token: null, user: null };
  }
};

export const storeAuth = (token, refreshToken, user) => {
  try {
    if (token) storage.set(AUTH_KEYS.token, token);
    if (refreshToken) storage.set(AUTH_KEYS.refreshToken, refreshToken);
    if (user) storage.set(AUTH_KEYS.user, JSON.stringify(user));
  } catch (error) {
    // eslint-disable-next-line no-console
    
  }
};

// Verify the stored token by hitting `/auth/me`. Preserves populated roles
// from the previous stored user if the new response only has ids.
export const checkAuth = async () => {
  try {
    const { user: storedUser } = getStoredAuth();
    const response = await apiClient.get('/auth/me');

    if (response.data && response.data.success && response.data.user) {
      const userData = response.data.user;
      let user = null;

      if (userData._doc) {
        user = {
          ...userData._doc,
          _id: userData._id || userData._doc._id,
          roles: userData._doc.roles || [],
        };
      } else {
        const numericKeys = Object.keys(userData).filter((key) => !isNaN(parseInt(key, 10)));
        const userFields = {};
        Object.keys(userData).forEach((key) => {
          if (!numericKeys.includes(key) && !key.startsWith('$') && key !== '__v') {
            userFields[key] = userData[key];
          }
        });
        user = userFields;
      }

      const apiRoles = user.roles || [];
      const hasPopulatedRoles =
        apiRoles.length > 0 &&
        apiRoles.some((role) => typeof role === 'object' && role.name);

      if (!hasPopulatedRoles && storedUser && storedUser.roles) {
        const storedHasPopulatedRoles = storedUser.roles.some(
          (role) => typeof role === 'object' && role.name
        );
        if (storedHasPopulatedRoles) {
          user.roles = storedUser.roles;
        }
      }

      if (user && user._id) {
        storage.set(AUTH_KEYS.user, JSON.stringify(user));
      }
      return { success: true, user, error: null };
    }

    return { success: false, user: null, error: 'Invalid response format' };
  } catch (error) {
    if (
      error.response?.status === 401 ||
      error.response?.data?.message?.includes('token') ||
      error.isAuthError
    ) {
      await logout();
      return { success: false, user: null, error: 'Invalid or expired token' };
    }
    return {
      success: false,
      user: null,
      error: error.response?.data?.message || error.message || 'Authentication check failed',
    };
  }
};
